export const WEB_FONTS_LOADED = "WEB_FONTS_LOADED";
export const WP_FOOTER_LOADED = "WP_FOOTER_LOADED";

const actions = {
  webFontsLoaded() {
    return {
      type: WEB_FONTS_LOADED
    };
  }
};

export default actions;
